import React from 'react';
import {Colors, FontStyles, Routes} from "../constants";
import {Flex} from "../common_style/flex";
import {NewStoryCardView, PlaceholderStoryCardView} from "../story_card/story_card_view";
import StoryCardView from "components/story_card";
import {backgrounds} from "components/tools_pane/tools_items";
import HTMLReactParser from "html-react-parser";
import PrintStory from "components/print_story";

function _getStory(props, obj, sharedFrom, i) {
    let title;
    try {
        title = HTMLReactParser(obj.data().title);
    } catch (e) {
        title = "";
    }
    return <StoryCardView key={'obj-' + i} title={title} onShare={() => props.onShare(obj)}
                          onDelete={() => props.onDelete(obj)} onClick={() => props.onStoryClick(obj)}
                          onEdit={() => props.onEdit(obj)}
                          shared={props.shared}
                          sharedFrom={sharedFrom}
                          onPdf={() => props.onPdf(obj)}
                          bgImage={obj.data().background ? backgrounds[obj.data().background].thumb : null}/>

}

function StoryGridView(props) {
    return <Flex row wrap hAlign={'center'} style={{overflowY: 'auto', overflowX: 'hidden', maxWidth: '1400px'}}>
        {props.shared ? null : <NewStoryCardView onClick={() => props.onNewStory()}/>}
        {props.stories.map((s, i) => _getStory(props, s, props.shared ? props.sharedFrom[s.uuid] : s.data().author, i))}
        {(props.stories.length > 8 || props.shared) ? null : [...Array(8 - props.stories.length).keys()].map((_) => <PlaceholderStoryCardView onClick={() => props.onNewStory()}/>)}
        {props.children}
    </Flex>
}

export default StoryGridView;